import React, { useCallback, useEffect, useState } from 'react';
import { useApiCaller } from '../utils/ApiUtilities';
import { getAdminQuestionUrl } from '../utils/UrlUtilities';
import { formatBdPst } from '../utils/DateUtilities';
import QuestionEditForm from './QuestionEditForm';
import CloseButton from './ui/CloseButton';

function Modal({ title, children, onClose }) {
    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ background: 'rgba(0,0,0,0.4)' }}
            onClick={onClose}
        >
            <div className="modal-dialog modal-xl" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <CloseButton onClick={onClose} />
                    </div>
                    <div className="modal-body">{children}</div>
                </div>
            </div>
        </div>
    );
}

export default function AdminRevisionInbox() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(null);
    const CallApi = useApiCaller();

    const reload = useCallback(async () => {
        setLoading(true);
        const url = getAdminQuestionUrl(
            1, 100, null, null, null, null, null, null, null, null, null,
            { mine: true, needsRevision: true }
        );
        const res = await CallApi({ url, method: 'GET' });
        if (res.success) setItems(res.data.questions || []);
        setLoading(false);
    }, [CallApi]);

    useEffect(() => { reload(); }, [reload]);

    return (
        <div className="container mt-4">
            <h2 className="mb-3">Revision Inbox</h2>
            <p className="text-muted">
                Questions you authored that the Super Admin has sent back for revision.
                Edit and save to clear the flag.
            </p>

            {loading ? <div>Loading…</div> : items.length === 0 ? (
                <div className="alert alert-success">No questions waiting on revision. </div>
            ) : (
                items.map((q) => (
                    <div key={q.question_id} className="card mb-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="mb-0">#{q.question_id} — {q.subject}</h5>
                                <span className="badge bg-warning text-dark">Needs Revision</span>
                            </div>
                            <div className="mb-2">
                                <strong>Level:</strong> {q.level || '—'}
                                {q.topic && <> · <strong>Topic:</strong> {q.topic}</>}
                                {q.exam && <> · <strong>Exam:</strong> {q.exam}</>}
                            </div>
                            <div className="mb-2" style={{ whiteSpace: 'pre-wrap' }}>{q.question_text}</div>

                            {q.super_admin_review_note && (
                                <div className="alert alert-warning">
                                    <div className="fw-bold mb-1">
                                        Note from {q.super_admin_reviewed_by?.name || 'Super Admin'}
                                        {q.super_admin_reviewed_at && (
                                            <small className="text-muted ms-2">
                                                {formatBdPst(q.super_admin_reviewed_at)}
                                            </small>
                                        )}
                                    </div>
                                    {q.super_admin_review_note}
                                </div>
                            )}

                            <button
                                className="btn btn-primary"
                                onClick={() => setEditing(q)}
                            >
                                Open & Edit
                            </button>
                        </div>
                    </div>
                ))
            )}

            {editing && (
                <Modal title={`Edit Question #${editing.question_id}`} onClose={() => setEditing(null)}>
                    <QuestionEditForm
                        question={editing}
                        onCancel={() => setEditing(null)}
                        onSave={() => { setEditing(null); reload(); }}
                    />
                </Modal>
            )}
        </div>
    );
}
